import { useEffect, useState } from "react";

export default function useTestTimer(estimatedMinutes) {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    if (!estimatedMinutes) return;
    setTimeRemaining(estimatedMinutes * 60);
  }, [estimatedMinutes]);

  useEffect(() => {
    if (timeRemaining <= 0) return;

    const interval = setInterval(() => {
      setTimeRemaining((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [timeRemaining]);

  return { timeRemaining, setTimeRemaining };
}
